<template>
  <canvas
    ref="canvas"
    width="2024"
    height="2024"
    class="w-full h-full object-contain"
  ></canvas>
</template>

<script>
import { defineComponent } from 'vue'
import emptyTransactions from '../../assets/lotties/empty_state.json'
import download from '../../assets/lotties/arrowDown.json'
import gift from '../../assets/lotties/gift.json'

export default defineComponent({
  name: 'LottieComponent',
  props: {
    loop: {
      type: Boolean,
      default: false,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    src: {
      type: String,
      default: '',
    },
    speed: {
      type: String,
      default: '1',
    },
    animationDuration: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      staticAnimation: false,
      files: {
        emptyTransactions: JSON.stringify(emptyTransactions),
        download: JSON.stringify(download),
        gift: JSON.stringify(gift),
      },
    }
  },
  mounted() {
    const canvas = this.$refs.canvas

    new window.DotLottie({
      canvas,
      src: this.src,
      loop: this.loop,
      autoplay: this.autoplay,
    })
  },
  methods: {},
  computed: {},
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
